module.exports = __webpack_public_path__ + "img/invoice-de-male-th.e593833e.png";